import Vue from 'vue'
import Vuex from 'vuex'
import { LOGIN, LOGOUT } from '@/utils/api.js'

const isAdminSide = location.pathname === '/admin.html'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title: '管理后台',
    isAdminSide: isAdminSide,
    user: null,
    request: {
      number: 0,
      // 0无请求 1请求中 2请求完毕
      state: 0
    },

    routers: [],

    auth: [{routeName: 'banner-list'}, { routeName: 'user-list' }]
  },

  mutations: {
    /**
     * 
     * @param {*} state
     * @param {*} payload type: add|reduce
     */
    updateRequestState (state, payload) {
      if (payload.type === 'add') {
        state.request.number++
        payload.state && (state.request.state = 1)
      } else if (payload.type === 'reduce') {
        state.request.number > 0 && state.request.number--
        payload.state && (state.request.state = 2)
      }
    },

    setRouters (state, routers) {
      state.routers = routers
    },

    login (state, payload) {
      state.user = payload
      let pre = localStorage.getItem('____p__u__ing__') ? JSON.parse($string.cdecode(localStorage.getItem('____p__u__ing__'))) : { times: 0}
      if (pre.username !== payload.username || pre.password !== payload.password) {
        pre.times = 0
      }
      localStorage.setItem('____p__u__ing__', $string.cencode(JSON.stringify({
        username: payload.username,
        password: payload.password,
        times: pre.times + 1
      })))
    },

    setAuth (state, payload) {
      state.auth = payload
    },

    logout (state) {
      state.user = null
      state.auth = []
      localStorage.removeItem('____p__u__ing__')
    }
  },

  actions: {
    requesting ({ commit }) {
      commit('updateRequestState', {
        type: 'add',
        state: 1
      })
    },
    addRequset ({ commit }) {
      commit('updateRequestState', {
        type: 'add'
      })
    },

    requested ({ commit }) {
      commit('updateRequestState', {
        type: 'reduce',
        state: 2
      })
    },

    logout ({commit, dispatch}) {
      return new Promise(resolve => {
        dispatch('requesting')
        LOGOUT().then(r => {
          dispatch('requested')
          if (r && r.status === 200) {
            commit('logout')
            resolve()
          } else {
            resolve(false)
          }
        })
      })
    },

    async login ({commit, dispatch}, user) {
      return new Promise(resolve => {
        dispatch('requesting')
        LOGIN(user).then(r => {
          dispatch('requested')
          if (r && r.status === 200) {
            commit('login', {
              username: user.username,
              password: user.password
            })
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },

    getAuth ({commit}) {
      return new Promise((resolve, reject) => {
        $get('/auth-free/account/all').then(r => {
          if (r && r.code === 200) {
            commit('setAuth', r.data)
            resolve()
          } else {
            reject()
          }
        })
      })
    },

    tabClose () {
      const pre = localStorage.getItem('____p__u__ing__') ? JSON.parse($string.cdecode(localStorage.getItem('____p__u__ing__'))) : { times: 0 }
      if (pre.times > 0) {
        localStorage.setItem('____p__u__ing__', $string.cencode(JSON.stringify({
          username: payload.username,
          password: payload.password,
          times: pre.times - 1
        })))
      }
    },

    /**
     * 自动登陆
     */
    autoLogin ({dispatch}) {
      return new Promise(resolve => {
        const user = localStorage.getItem('____p__u__ing__') ? JSON.parse($string.cdecode(localStorage.getItem('____p__u__ing__'))) : undefined
        if (user !== undefined) {
          const data = {
            username: user.username,
            password: user.password
          }
          dispatch('login', data).then(r => resolve(r))
        } else {
          dispatch('logout')
          resolve(false)
        }
      })
    },

    //--------- router
    setRouters ({ commit }, routers) {
      return new Promise(resolve => {
        commit('setRouters', routers)
        resolve()
      })
    }
  },

  getters: {
    isRequesting (state) {
      return state.request.state === 1
    },

    isRequested (state) {
      return state.request.state === 2
    },

    isLogin (state) {
      return !!localStorage.getItem('____p__u__ing__')
    },

    isUser (state) {
      return state.user !== null
    },

    auths: state => {
      return state.auth.map(item => item.routeName.split('/').join('-'))
    },

    menus: state => {
      const auths = state.auth.map(item => item.routeName.split('/').join('-'))

      const getMenus = (routers) => {
        let menus = []
        if (typeof(routers) === 'object' && routers !== null) {
          if (Array.isArray(routers)) {
            routers.map(router => {
              const menu = filterMenus(router)
              menu && menus.push(menu)
            })
          } else {
            const menu = filterMenus(routers)
            menu && menus.push(menu)
          }
        }
        return menus
      }

      const filterMenus = (router) => {
        if (router) {
          let { redirect, name, children, meta: { title, inMenu } } = router
          if (inMenu) {
            let indexOfChildren = 0
            if (redirect) {
              name = redirect.name
            }
            while (!isInAuths(name) && children && children.length > indexOfChildren) {
              name = children[indexOfChildren].name
              indexOfChildren += 1
            }
            if (isInAuths(name)) {
              router.name = name
              if (children) {
                router.children = getMenus(router.children)
              }
              router.title = title ? title : name
              return router
            } else {
              return false
            }
          } else {
            return false
          }
        }
      }

      const isInAuths = (name) => auths.findIndex(auth => auth.indexOf(name) !== -1) !== -1 || true

      return getMenus(state.routers)
    },

    routers: state => {
      return state.auth.map(item => item.routeName)
    }
  }
})
